var UA = window.navigator.userAgent.toLowerCase()

function test(needle) {
  return needle.test(UA)
}

var IsAndroid = test(/android|htc/)
var IsIPad = !IsAndroid && test(/ipad/)
var IsIPhone = !IsAndroid && test(/ipod|iphone/)
var IsIPhoneX =
  /iphone/gi.test(navigator.userAgent) &&
  ((screen.height === 812 && screen.width === 375) ||
    (screen.width === 414 && screen.height === 896))
var IsIOS = IsIPad || IsIPhone
var IsWeixin = test(/micromessenger/)

var IsTitans = !IsMiniprogram && test(/titansx|titans/)
var IsMeituan = !IsMiniprogram && test(/meituangroup|com.meituan.imeituan/)
var IsDianping = test(/com.dianping/)
var IsMiniprogram = test(/miniprogram/)

var env = {
  isAndroid: IsAndroid,
  isIPad: IsIPad,
  isIPhone: IsIPhone,
  isIPhoneX: IsIPhoneX,
  isIOS: IsIOS,
  isWeixin: IsWeixin,
  isTitans: IsTitans, // 美团统一容器
  isMeituan: IsMeituan, // 美团主App
  isDianping: IsDianping, // 大众点评App
  isMiniprogram: IsMiniprogram, // 小程序（所有）
}

var documentElement = window.document.documentElement
for (var i in env) {
  if (env[i]) {
    documentElement.className += ' ' + i.replace('Is', '').toLowerCase()
  }
}

export default env
